import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { recoverCurrentChunk } from './app/chunk-recovery';
import './styles/globals.css';
import './paper/tokens.css';

window.addEventListener('vite:preloadError', (event) => {
  if (recoverCurrentChunk((event as Event & { payload: unknown }).payload)) event.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
